<template>
  <validation-observer
    v-slot="observer"
    slim
  >
    <form-section
      id="date-of-birth"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row
        :label="!isAdditional ? 'What is your date of birth?' : 'What is their date of birth?'"
        help-text="Insurance providers need to know this as it can affect your premium price."
        :error="formObserver.validated && !observer.valid"
      >
        <time-zone-warning
          v-if="isWarningTextShown"
          :question-date="questionData[questionFields.dateOfBirth]"
        />
        <qz-date-select
          v-model="questionData[questionFields.dateOfBirth]"
          :form-observer="formObserver"
          :data-test="snakeCase(questionFields.dateOfBirth)"
          :vid="`${stepId}_date-of-birth`"
          :year-options="dateOfBirthYearItems"
          :date-rule="{
            taxiDateOfBirth: {
              dateOfInsuranceStart: stepData.dateOfInsuranceStart,
            },
            checkTaxiAge: {
              dateOfInsuranceStart: stepData.dateOfInsuranceStart,
              taxiUsedFor: stepData.taxiUsedFor,
            },
          }"
        />
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import { computed } from '@vue/composition-api';
import { UtcDate } from '@/helpers/date';
import QuestionBase from './Base';

import TimeZoneWarning from '@/components/TimeZoneWarning/TimeZoneWarning.vue';
import useTimeZoneWarning from '@/composables/useTimeZoneWarning.js';

export default {
  name: 'question-date-of-birth',
  extends: QuestionBase,
  components: {
    TimeZoneWarning,
  },
  data () {
    return {
      fields: ['dateOfBirth'],
    };
  },
  computed: {
    dateOfBirthYearItems () {
      const maxDateOfBirthDate = new UtcDate().subYears(this.constants.INSURER_MIN_AGE);
      const end = maxDateOfBirthDate.getFullYear();
      const start = end - (this.constants.INSURER_MAX_AGE - this.constants.INSURER_MIN_AGE);
      return Array(end - start + 1).fill().map((_, idx) => start + idx).reverse();
    },
  },
  setup (props) {
    const isWarningTextShown = computed((componentContext) => {
      return useTimeZoneWarning(
        props.formObserver,
        `${props.stepId}_date-of-birth`,
        {
          taxiDateOfBirth: {
            dateOfInsuranceStart: componentContext.stepData.dateOfInsuranceStart,
          },
          checkTaxiAge: {
            dateOfInsuranceStart: componentContext.stepData.dateOfInsuranceStart,
            taxiUsedFor: componentContext.stepData.taxiUsedFor,
          },
        },
      );
    });

    return {
      isWarningTextShown,
    };
  },
};
</script>
